import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: '¿Cómo recibo el Megapack después de comprar?',
  a: 'El acceso es inmediato. Una vez que se confirma el pago por Mercado Pago, te llega un mail automático con el link para descargar todos los PDFs (tomos y bonos) a tu celular o computadora.'
}, {
  q: '¿Sirve si nunca hice ningún curso de entrenamiento?',
  a: 'Sí, está diseñado exactamente para eso. El lenguaje es simple, directo y sin tecnicismos complicados. Te da la estructura que te falta para dejar de improvisar.'
}, {
  q: '¿Necesito instalaciones especiales o me alcanza con una cancha alquilada?',
  a: 'Te alcanza con una cancha, pelotas y conos. Todos los ejercicios y sistemas están pensados para la realidad del futsal amateur argentino, no para equipos europeos con presupuesto infinito.'
}, {
  q: '¿Los 6 bonos están incluidos en las dos ofertas?',
  a: 'Sí. Tanto si elegís el plan Estándar como el Élite, te llevás los 6 bonos estratégicos gratis.'
}, {
  q: '¿Sirve si entreno un equipo escolar o universitario?',
  a: 'Totalmente. Los principios tácticos, la gestión de grupo y la planificación de temporada aplican perfecto para equipos formativos mayores o universitarios.'
}, {
  q: '¿Sirve si mi equipo está en la liga más básica del barrio?',
  a: 'Más todavía. Es donde más diferencia vas a hacer, porque la mayoría de los equipos en esas ligas no tienen ningún tipo de sistema ni planificación.'
}, {
  q: '¿Qué diferencia tiene con los videos gratuitos de YouTube?',
  a: 'YouTube te da ejercicios sueltos sin contexto. El Megapack te da un SISTEMA. Sabés qué hacer el martes, qué hacer el jueves y cómo eso se conecta con el partido del sábado.'
}, {
  q: '¿Por qué elegir el Élite y no el estándar?',
  a: 'El Élite te resuelve dos problemas críticos que el estándar no cubre a fondo: cómo hacer que el equipo no se funda físicamente en el segundo tiempo, y cómo manejar la cabeza del jugador cuando hay presión.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí, 100% real. Tenés 7 días. Si sentís que no te sirve, nos mandás un mail y te devolvemos la plata por Mercado Pago. Sin vueltas.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-10 md:py-20 bg-[#0F172A] px-4" data-id="element-142">
      <div className="max-w-3xl mx-auto" data-id="element-143">
        <div className="text-center mb-8 md:mb-12" data-id="element-144">
          <p className="text-xs md:text-sm text-gold font-bold uppercase tracking-wide mb-1 md:mb-2" data-id="element-145">
            DUDAS COMUNES
          </p>
          <h2 className="font-display text-3xl md:text-5xl text-white uppercase" data-id="element-146">
            PREGUNTAS FRECUENTES
          </h2>
        </div>

        <div className="space-y-2 md:space-y-3" data-id="element-147">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`border rounded-lg md:rounded-xl overflow-hidden transition-colors ${isOpen ? 'border-gold/40 bg-gray-800' : 'border-gray-700 bg-gray-800/60'}`} data-id="element-148">
                <button onClick={() => setOpenIndex(isOpen ? null : i)} className="w-full text-left px-4 md:px-6 py-3 md:py-4 flex items-center justify-between focus:outline-none hover:bg-gray-800 transition-colors" aria-expanded={isOpen} data-id="element-149">
                  <span className="font-bold text-white text-sm md:text-base pr-4" data-id="element-150">
                    {faq.q}
                  </span>
                  <ChevronDown className={`text-gold shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} size={18} data-id="element-151" />
                </button>
                <AnimatePresence data-id="element-152">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-153">
                      <div className="px-4 md:px-6 pb-3 md:pb-4 text-gray-300 text-xs md:text-sm leading-relaxed border-t border-gray-700 pt-2 md:pt-3" data-id="element-154">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}